import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompContext } from '@/context/__project__/CompContext'

import { CompIconButtonWrapperCore } from '../core/icon-button/wrapper'
import { CompIconButton } from './CompIconButton'

/**
 * CompIconButtonWrapper
 */
function CompIconButtonWrapper() {
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const actionContext = useBuilderActionContextV2()

  return (
    <CompIconButtonWrapperCore infos={{ ...compContext, activeLayer }} action={actionContext}>
      {(props, ref) => <CompIconButton {...props} ref={ref} />}
    </CompIconButtonWrapperCore>
  )
}

export default CompIconButtonWrapper
